import { render, staticRenderFns } from "./expand-icon.vue?vue&type=template&id=6c9b67df&scoped=true"
var script = {}
import style0 from "./expand-icon.vue?vue&type=style&index=0&id=6c9b67df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9b67df",
  null
  
)

export default component.exports